import { useQuery } from '@tanstack/react-query';
import { getCampaignById } from '../api/campaigns';

export function useCampaign(id: string | null) {
  return useQuery({
    queryKey: ['campaign', id],
    queryFn: () => getCampaignById(id!),
    enabled: id != null && id !== '',
  });
}
